import mixpanel from "mixpanel-browser";
import config from "../config";

const trackEvent = (eventName, properties) => {
  try {
    if (!config.IS_PROD) return;
    mixpanel.track(eventName, { ...properties });
  } catch (err) {
    console.log("Mixpanel tracking error:", err);
  }
};

const identifyUser = ({ userId, userEmail, userName, type }) => {
  try {
    if (!config.IS_PROD) return;
    const userDetails = {
      id: userId,
      email: userEmail,
      name: userName,
      accountType: type,
    };
    mixpanel.identify(userId);
    mixpanel.track("Sign In", userDetails);
    mixpanel.people.set_once(userDetails);
  } catch (err) {
    console.log("Mixpanel identify error:", err);
  }
};

const mixpanelClear = () => {
  if (!config.IS_PROD) return;
  mixpanel.track("Logout");
  mixpanel.reset();
};

export { trackEvent, identifyUser, mixpanelClear };
